var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TheHeader',{style:({ zIndex: _vm.views.length })}),_vm._l((_vm.views),function(ref,i){
var name = ref.name;
return _c('router-view',{key:name,style:({ zIndex: i }),attrs:{"name":name,"id":name}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }